import apiClient from './api';
import {
  ApiResponse,
  TaskCategory,
  TaskCategoryPayload,
  TaskDefinition,
  TaskDefinitionPayload,
  TaskSubtaskRelation,
  TaskSubtaskRelationPayload,
} from '../types';

const taskMetadataBasePath = '/admin/task-metadata';

export const taskMetadataApi = {
  getTaskDefinitions: (): Promise<ApiResponse<TaskDefinition[]>> =>
    apiClient.get(`${taskMetadataBasePath}/task-definitions`),

  saveTaskDefinition: (
    payload: TaskDefinitionPayload
  ): Promise<ApiResponse<TaskDefinition>> =>
    apiClient.post(`${taskMetadataBasePath}/task-definitions`, payload),

  getTaskCategories: (): Promise<ApiResponse<TaskCategory[]>> =>
    apiClient.get(`${taskMetadataBasePath}/task-categories`),

  saveTaskCategory: (
    payload: TaskCategoryPayload
  ): Promise<ApiResponse<TaskCategory>> =>
    apiClient.post(`${taskMetadataBasePath}/task-categories`, payload),

  getTaskSubtaskRelations: (): Promise<ApiResponse<TaskSubtaskRelation[]>> =>
    apiClient.get(`${taskMetadataBasePath}/task-subtask-relations`),

  saveTaskSubtaskRelation: (
    payload: TaskSubtaskRelationPayload
  ): Promise<ApiResponse<TaskSubtaskRelation>> =>
    apiClient.post(`${taskMetadataBasePath}/task-subtask-relations`, payload),

  refreshTaskMetadataRegistry: (): Promise<ApiResponse<string>> =>
    apiClient.post(`${taskMetadataBasePath}/refresh`),
};
